import { render, staticRenderFns } from "./radar.vue?vue&type=template&id=b04e1c24&scoped=true&"
import script from "./radar.vue?vue&type=script&lang=js&"
export * from "./radar.vue?vue&type=script&lang=js&"
import style0 from "./radar.vue?vue&type=style&index=0&id=b04e1c24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04e1c24",
  null
  
)

export default component.exports